import FunImage from "./FunImage";
export default FunImage;